"use strict";
var set_ap_programs_controller_ts_1 = require("./set-ap-programs.controller.ts");
var templateUrl = require("./set-ap-programs.html");
exports.setApPrograms = {
    templateUrl: templateUrl,
    controller: set_ap_programs_controller_ts_1.SetApProgramsController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};



/** WEBPACK FOOTER **
 ** ./app/set-ap-programs/set-ap-programs.ts
 **/